// src/components/admin/DataTable.jsx
import React from 'react';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const DataTable = ({ 
  data = [], 
  columns = [], 
  isLoading = false, 
  onSort = null, 
  sortConfig = null,
  emptyMessage = "Aucune donnée disponible",
  searchQuery = "",
  filters = {}
}) => {
  // Get sort indicator for table headers
  const getSortIndicator = (key) => {
    if (!sortConfig || sortConfig.key !== key) return '';
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  // Check if filters are applied
  const areFiltersApplied = () => {
    return searchQuery || Object.values(filters).some(value => value !== 'all' && value !== '');
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {isLoading && data.length === 0 ? (
        <div className="flex justify-center my-8">
          <LoadingSpinner />
        </div>
      ) : data.length === 0 ? (
        <div className="p-4 text-center text-gray-500 text-sm">
          {areFiltersApplied() 
            ? 'Aucun résultat ne correspond à vos critères de recherche.' 
            : emptyMessage}
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {columns.map((column, index) => (
                    <th 
                      key={index}
                      className={`px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${column.sortable ? 'cursor-pointer hover:bg-gray-100' : ''}`}
                      onClick={() => column.sortable && onSort && onSort(column.key)}
                    >
                      <div className="flex items-center">
                        {column.label} {column.sortable && getSortIndicator(column.key)}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.map((row, rowIndex) => (
                  <tr key={row.id || row._id || rowIndex} className="hover:bg-gray-50">
                    {columns.map((column, colIndex) => (
                      <td 
                        key={colIndex} 
                        className={`px-4 py-2 text-sm whitespace-nowrap ${column.className || ''}`}
                      >
                        {column.render ? column.render(row[column.key], row) : row[column.key] || '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default DataTable;